import React from "react";
import { object, number } from "prop-types";

import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar-elements";
import { getImagesAndCards } from "./photo-story-elements";
import PhotoStorySlider from "./photo-slider";
import StoryHeader from "../header-block";

import "./photo-story.m.css";

const PhotoStory = ({ story, index }) => {
  const { imageElements, newCards } = getImagesAndCards(story.cards);

  return (
    <div styleName="photo-wrapper">
      <div styleName="story-wrapper">
        <div>
          {imageElements.length ? <PhotoStorySlider story={story} images={imageElements} /> : null}
          <StoryHeader story={story} showHeroImage={false} />
          <StoryElements story={story} cards={newCards} index={index} disableBodyAds />
        </div>
        <div>
          <StorySideBar index={index} story={story} />
        </div>
      </div>
    </div>
  );
};

PhotoStory.propTypes = {
  story: object,
  index: number,
};

export default PhotoStory;
